import { useEffect, useState } from 'react';

const DEFAULT_AUTO_DISMISS_MS = 40000;

const RowLimitExportModal = ({
  message,
  onClose,
  autoDismissMs = DEFAULT_AUTO_DISMISS_MS,
}) => {
  // Drives the shrinking countdown bar (100% -> 0%).
  const [remaining, setRemaining] = useState(100);

  useEffect(() => {
    const closeTimer = setTimeout(() => {
      onClose?.();
    }, autoDismissMs);

    const start = performance.now();
    const tick = setInterval(() => {
      const elapsed = performance.now() - start;
      const pct = Math.max(0, 100 - (elapsed / autoDismissMs) * 100);
      setRemaining(pct);
    }, 50);

    return () => {
      clearTimeout(closeTimer);
      clearInterval(tick);
    };
  }, [autoDismissMs, onClose]);

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 10000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundColor: '#fff',
          borderRadius: 12,
          padding: '28px 36px 0',
          maxWidth: 460,
          width: '90%',
          boxShadow: '0 8px 32px rgba(0,0,0,0.25)',
          overflow: 'hidden',
          textAlign: 'center',
        }}
      >
        <div
          style={{
            width: 56,
            height: 56,
            margin: '0 auto 16px',
            borderRadius: '50%',
            backgroundColor: '#fff4e5',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 30,
            color: '#e0a106',
          }}
        >
          &#9888;
        </div>

        <div
          style={{
            fontSize: 18,
            fontWeight: 700,
            color: '#333',
            marginBottom: 10,
          }}
        >
          Export too large
        </div>

        <div
          style={{
            fontSize: 14,
            color: '#555',
            lineHeight: 1.6,
            marginBottom: 20,
          }}
        >
          {message}
        </div>

        <button
          type="button"
          className="btn btn-success"
          onClick={onClose}
          style={{ marginBottom: 22, minWidth: 120 }}
        >
          Got it
        </button>

        {/* Countdown bar — shows the modal is auto-dismissing */}
        <div
          style={{
            height: 4,
            width: `${remaining}%`,
            background: 'linear-gradient(90deg, #1e6b28, #2e8b3a, #4db85a)',
            borderRadius: 99,
            transition: 'width 0.05s linear',
            margin: '0 -36px',
          }}
        />
      </div>
    </div>
  );
};

export default RowLimitExportModal;
